import axios from "axios";
import authHeader from "./auth-header";
import { BASE_URL } from "./config";

export const sendCompanySearch = (company) => {
  try {
    return axios.post(BASE_URL + "cases/search", { company_name: company });
  } catch (e) {
    console.log(e);
  }
};

export const sendCompanySearchBackUp = (company) => {
  try {
    return axios.post(BASE_URL + "cases/backup_search", {
      company_name: company,
    });
  } catch (e) {
    console.log(e);
  }
};

export const validateURL = (url) => {
  try {
    return axios.post(BASE_URL + "cases/validateURL", { url: url });
  } catch (e) {
    console.log(e);
  }
};

export const searchCompanyForCorrectUrl = (company_name) => {
  try {
    return axios.post(
      BASE_URL + "cases/searchCompanyForCorrectUrl",
      { company_name },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const saveCase = (caseName, domain) => {
  try {
    return axios.post(
      BASE_URL + "cases/saveCase",
      { caseName, domain },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const activateCase = (caseName, activate) => {
  try {
    return axios.post(
      BASE_URL + "cases/activateCase",
      { caseName, activate },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const deleteCase = (caseName) => {
  try {
    return axios.post(
      BASE_URL + "cases/deleteCase",
      { caseName },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getCases = () => {
  try {
    return axios.get(BASE_URL + "cases/getCases", { headers: authHeader() });
  } catch (e) {
    console.log(e);
  }
};
